import React from 'react';
export const InfoList = ({ items }) => (React.createElement("ul", { className: "pl:24" }, items.map(item => (React.createElement("li", { key: item }, item)))));
